'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _reactRedux = require('react-redux');

var _actions = require('../../../actions');

var _actions2 = _interopRequireDefault(_actions);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Messages', 'App');

function mapStateToProps(state) {
    return {
        pending: state.cart.sendingOrder,
        termsUrl: state.cart.termsUrl,
        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changes).length || (0, _keys2.default)(state.cart.changedOptions).length || state.cart.settingCoupon)
    };
}

var mapDispatchToProps = {
    sendOrder: _actions2.default.sendOrder
};

var OrderConfirmation = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(OrderConfirmation, _React$PureComponent);

    function OrderConfirmation() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, OrderConfirmation);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = OrderConfirmation.__proto__ || (0, _getPrototypeOf2.default)(OrderConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.submitOrder = function (e) {
            e.preventDefault();
            if (_this.props.processing) return;
            _this.props.sendOrder();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(OrderConfirmation, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                pending = _props.pending,
                processing = _props.processing,
                termsUrl = _props.termsUrl;

            var btnClass = 'btn btn--xl btn--green';
            if (pending) {
                btnClass += ' btn--pending';
            }
            if (processing) {
                btnClass += ' btn--inactive';
            }
            return _react2.default.createElement(
                'div',
                { className: 'cart__submit text-center' },
                _react2.default.createElement(
                    'div',
                    { className: 'above__submit mb-4' },
                    _react2.default.createElement('i', { dangerouslySetInnerHTML: { __html: Resx.Messages.CartConfirmationMessage.replace('{0}', termsUrl) } })
                ),
                _react2.default.createElement(
                    'button',
                    { className: btnClass, onClick: this.submitOrder },
                    Resx.App.BindOrderKmc
                )
            );
        }
    }]);
    return OrderConfirmation;
}(_react2.default.PureComponent), _class2.propTypes = {
    pending: _propTypes2.default.bool,
    sendOrder: _propTypes2.default.func,
    processing: _propTypes2.default.bool
}, _temp2)) || _class);
exports.default = OrderConfirmation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step4/OrderConfirmation.js
// module id = 1144
// module chunks = 0